module.exports = __webpack_public_path__ + "img/empty.9576264d.png";